import React, { useState, useEffect } from "react";
import {
  fetchAllModules,
  fetchAvailableLwNames,
} from "../../actions/moduleActions";
import { Button, Row, Col, Input, Table } from "reactstrap";
import CreateNewModule from "../../components/Modal/CreateNewModule";
import { PacmanLoader } from "react-spinners";
import ModuleTypeIcon from "../../components/Module/ModuleTypeIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CourseAdminNav from "../../components/Navigation/CourseAdminNav";
import ReactTooltip from "react-tooltip";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import { GetAvailableModuleAnswers } from "../../actions/teacherQueries";
import moment from "moment";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

function ModulesList(props) {
  const [filterSearch, setFilterSearch] = useState("");
  const [modules, setModules] = useState([]);
  const [createNewModuleModal, setCreateNewModuleModal] = useState(false);
  const [editModule, setEditModule] = useState(null);
  const modulesReducer = useSelector((state) => state.moduleReducer);
  const lwFileNames = useSelector((state) => state.lwFileNameReducer);
  const availableModuleAnswers = GetAvailableModuleAnswers();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllModules());
    dispatch(fetchAvailableLwNames());
  }, [dispatch]);

  useEffect(() => {
    setModules(modulesReducer.modules);
  }, [modulesReducer.modules]);

  useEffect(() => {
    setModules(
      modulesReducer.modules.filter((it) =>
        it.name.toLowerCase().includes(filterSearch.toLowerCase())
      )
    );
  }, [filterSearch, modulesReducer.modules]);

  const handleOpenAnswers = (moduleId) => {
    axios
      .get(`${API_BASE_URL}/Module/GetModuleAnswers?moduleId=${moduleId}`, {
        responseType: "blob",
      })
      .then((response) => {
        const file = new Blob([response.data], {
          type: "application/pdf",
        });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        window.open(fileURL, "Facit", 'fullscreen="yes"');
      })
      .catch(async (error) => {
        let responseObj = await error.response.data.text();
        if (responseObj.trim() === "FileNotFound") {
          toast.warn(
            <FormattedMessage id="Error_Code_Module_Answers_FileNotFound" />,
            TOAST_CONFIG
          );
        } else {
          toast.warn(
            responseObj ? (
              responseObj
            ) : (
              <FormattedMessage id="GenericApiError" />
            )
          );
        }
      });
  };

  const loadModules = () => {
    dispatch(fetchAllModules());
  };

  const handleFilterSearch = (event) => {
    setFilterSearch(event.target.value);
  };

  if (modulesReducer.loading === true || availableModuleAnswers.isLoading) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }
  const handleOpenAddNewModule = () => {
    setEditModule(null);
    setCreateNewModuleModal(true);
  };

  const handleOpenEditModule = (module) => {
    setEditModule(module);
    setCreateNewModuleModal(true);
  };

  const handleDeleteModule = (moduleId) => {
    axios
      .delete(`${API_BASE_URL}/Module/${moduleId}`)
      .then((response) => {
        toast.success("Modul raderad", TOAST_CONFIG);
      })
      .catch((err) => {
        toast.warn(err.response.data, TOAST_CONFIG);
      });
  };
  const handleToggleEditModal = () => {
    setCreateNewModuleModal(!createNewModuleModal);
    setEditModule(null);
    loadModules();
  };

  var mappedModulesComponent = modules.map((module, id) => {
    return (
      <tr key={id}>
        <td>
          <ModuleTypeIcon moduleType={module.moduleType} />
        </td>
        <td
          style={{
            maxWidth: "200px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <p
            title={module.name}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {" "}
            {module.name}
          </p>
          <span className="mt-2">
            {module.courses.map((course) => {
              return (
                <p className="small" title={course.name}>
                  <em>{course.name}</em>
                </p>
              );
            })}
          </span>
        </td>
        <td style={{ textAlign: "center" }}>
          {module.isFinalExam ? (
            <span>
              <FontAwesomeIcon icon="check" />
            </span>
          ) : (
            ""
          )}
        </td>
        <td style={{ textAlign: "center" }}>
          {module.maxScoreIsSetByModule ? (
            <span>
              <FontAwesomeIcon icon="check" />
            </span>
          ) : (
            ""
          )}
        </td>
        <td style={{ textAlign: "center" }}>
          {module.isFactModule ? (
            <span>
              <FontAwesomeIcon icon="check" />
            </span>
          ) : (
            ""
          )}
        </td>
        <td style={{ maxWidth: "120px" }}>{module.qApiId}</td>
        <td style={{ textAlign: "right" }}>
          <p>{module.maxScore}</p>
          <p>{module.approveScoreLimit}%</p>
        </td>
        <td style={{ textAlign: "right" }}>
          <p>{module.maxActivityPoints}</p>
        </td>
        <td
          style={{
            maxWidth: "50px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={module.code}
        >
          {module.code}
        </td>
        <td
          style={{
            maxWidth: "300px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <p> {module.description}</p>
        </td>
        <td style={{ textAlign: "right" }}>
          <p>{module.id}</p>
        </td>
        <td style={{ textAlign: "right" }}>
          <p>{module.moduleCoupleId}</p>
        </td>
        <td
          style={{
            maxWidth: "100px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={module.lwGuid}
        >
          {module.lwGuid}
        </td>
        <td
          style={{
            maxWidth: "200px",
          }}
        >
          <p
            title={module.url}
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {" "}
            {module.url}
          </p>
        </td>
        <td>
          {availableModuleAnswers.data.some(
            (mod) => mod.moduleId === module.id
          ) ? (
            <Button
              outline
              size="sm"
              color="primary"
              onClick={() => handleOpenAnswers(module.id)}
              title={
                "Datum för uppladdning: " +
                moment(
                  availableModuleAnswers.data.find(
                    (item) => item.moduleId === module.id
                  ).answersFileDate
                ).format("YYYY-MM-DD") +
                " Filnamn: " +
                availableModuleAnswers.data.find(
                  (item) => item.moduleId === module.id
                ).answersFile
              }
            >
              <FontAwesomeIcon icon="check" />
            </Button>
          ) : (
            ""
          )}
        </td>
        <td>
          <Button
            size="sm"
            outline
            color="primary"
            className="me-2"
            title={"Redigera modul:" + module.name}
            onClick={() => {
              handleOpenEditModule(module);
            }}
          >
            <FontAwesomeIcon icon="edit" title="Editera" />
          </Button>
          <Button
            size="sm"
            outline
            color="danger"
            title={"Radera modul:" + module.name}
            onClick={() => handleDeleteModule(module.id)}
          >
            <FontAwesomeIcon icon="trash" title="Radera" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <div>
      <ReactTooltip type="info" multiline={true} />
      <CourseAdminNav location="modules" history={props.history} />

      <div
        className="container-fluid admin-container"
        style={{ overflowX: "auto" }}
      >
        <Row>
          <Col className="col-12">
            <Row>
              <Col className="col-4">
                <Input
                  style={{ marginTop: "-10px", marginBottom: "10px" }}
                  className="search-input"
                  placeholder="Sök modul"
                  onChange={handleFilterSearch.bind(this)}
                />
              </Col>
              <Col className="col-8">
                <Button
                  size="md"
                  outline
                  color="primary"
                  className="float-end"
                  style={{ marginTop: "-10px", marginBottom: "10px" }}
                  onClick={() => {
                    handleOpenAddNewModule();
                  }}
                >
                  <FontAwesomeIcon icon="plus" />
                  &nbsp;
                  <span className="">
                    <FormattedMessage id="NewModule" />
                  </span>
                </Button>
              </Col>
            </Row>
            <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <Table hover className="table table-striped">
                <thead className="sticky-header">
                  <tr>
                    <th>
                      <FormattedMessage id="Type" />
                    </th>
                    <th>
                      <FormattedMessage id="Name" />
                      <p className="small mb-0">
                        <FormattedMessage id="ConnectedTo" />
                      </p>
                    </th>
                    <th>
                      <FormattedMessage id="FinalExam" />
                    </th>
                    <th>
                      <FormattedMessage id="Gy25" />
                    </th>
                    <th>
                      <FormattedMessage id="FactModule" />
                    </th>
                    <th>
                      <FormattedMessage id="QApiId" />
                    </th>
                    <th style={{ textAlign: "right" }}>
                      <FormattedMessage id="Score" />
                      <p className="small mb-0">
                        <FormattedMessage id="Max" />,
                      </p>
                      <p className="small mb-0">
                        <FormattedMessage id="Views.Teacher.TeacherModule.CourseLimit" />
                      </p>
                    </th>
                    <th>
                      <FormattedMessage id="ActivityPoints" />
                    </th>
                    <th>
                      <FormattedMessage id="Code" />
                    </th>
                    <th>
                      <FormattedMessage id="Description" />
                    </th>
                    <th>
                      <FormattedMessage id="ModuleId" />
                    </th>
                    <th>
                      <FormattedMessage id="CoupleId" />
                    </th>
                    <th>
                      <FormattedMessage id="LwGuid" />
                    </th>
                    <th>
                      <FormattedMessage id="Url" />
                    </th>
                    <th>
                      <FormattedMessage id="HasAnswers" />
                    </th>
                    <th>
                      <FormattedMessage id="Edit" />
                    </th>
                  </tr>
                </thead>
                <tbody>{mappedModulesComponent}</tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </div>
      <CreateNewModule
        isOpen={createNewModuleModal}
        toggle={() => handleToggleEditModal()}
        reloadModules={loadModules}
        lwFileNames={lwFileNames}
        moduleToEdit={editModule}
        gy25Modules={modulesReducer.modules.filter(
          (m) => m.maxScoreIsSetByModule
        )}
      />
    </div>
  );
}

export default ModulesList;
